/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type Modification = {
  date?: Date | undefined;
};

/** @internal */
export const Modification$inboundSchema: z.ZodType<
  Modification,
  z.ZodTypeDef,
  unknown
> = z.object({
  date: z.string().datetime({ offset: true }).transform(v => new Date(v))
    .optional(),
});
/** @internal */
export type Modification$Outbound = {
  date?: string | undefined;
};

/** @internal */
export const Modification$outboundSchema: z.ZodType<
  Modification$Outbound,
  z.ZodTypeDef,
  Modification
> = z.object({
  date: z.date().transform(v => v.toISOString()).optional(),
});

export function modificationToJSON(modification: Modification): string {
  return JSON.stringify(Modification$outboundSchema.parse(modification));
}
export function modificationFromJSON(
  jsonString: string,
): SafeParseResult<Modification, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Modification$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Modification' from JSON`,
  );
}
